import { render, staticRenderFns } from "./CertificateCheckPage.vue?vue&type=template&id=e1483a8c"
import script from "./CertificateCheckPage.vue?vue&type=script&lang=js"
export * from "./CertificateCheckPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports